import React, {Component} from "react";
import {connect} from "react-redux";
import {deleteAccount} from "../../utils/API";
import Objects from "../../redux/Objects"
import {sessionDestroy} from "../../history/Session";
import QuestionModal from "../utils/QuestionModal";
import InputMaterial from "../shared/InputMaterial";
import {history} from "../../history/History";

class DeleteAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirm: ''
        }
    }

    render() {
        return (
            <div className="contain-app">
                <button className="back-btn" onClick={() => history.goBack()}>
                    <i className="icon-arrow_back_ios"/>
                </button>
                <div>
                    <div
                        className="p-3 d-flex text-center justify-content-center align-items-center flex-column">
                        <p>From this section you can delete your account</p>
                        <p>By deleting the account, all the following information will be deleted</p>
                        <p>• Personal Information</p>
                        <p>• Your tasks</p>
                        <p>• Credit card information</p>
                        <p>• Your payments</p>
                        <p>Enter 'CONFIRM' to delete account</p>
                        <InputMaterial
                            value={this.state.confirm}
                            title="Type 'CONFIRM'"
                            className="mr-1"
                            onChange={(evt) => this.setState({confirm: evt.target.value})}
                        />
                        <p className="red-color mt-3">Note: This operation is irreversible</p>
                        {this.state.confirm === 'CONFIRM' && <button className="mt-3 waves-effect waves-light btn-large white w-100 no-uppercase bold" onClick={() => {
                            this.setState({
                                showNotice: true
                            })
                        }}>
                            <span className="black-text">
                            Delete Account
                            </span>
                        </button>}
                        <QuestionModal show={this.state.showNotice}
                                       onHide={() => this.setState({showNotice: false})}
                                       acceptTitle="Yes"
                                       rejectTitle="No"
                                       onReject={() => this.setState({showNotice: undefined})}
                                       hideButton={this.state.deleteApi}
                                       onAccept={() => {
                                           this.setState({deleteApi: true});
                                           deleteAccount(() => {
                                               sessionDestroy();
                                           }, () => {
                                               this.setState({deleteApi: false});
                                           });
                                       }}
                        >
                            <div className="text-center p-3">
                                <span>Are you sure about deleting your account ? This operation is irreversible</span>
                            </div>
                        </QuestionModal>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch,

    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        height: state.param[Objects.height],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount)
